// Reports must not silently stop at the API's per-request row limit.
export async function readReportRows<T>(
  page: (from: number, to: number) => PromiseLike<{ data: T[] | null; error: unknown }>,
) {
  const rows: T[] = [];
  const pageSize = 500;
  for (let offset = 0; ; offset += pageSize) {
    const result = await page(offset, offset + pageSize - 1);
    if (result.error) throw result.error;
    if (!Array.isArray(result.data)) throw new Error('Report response is missing rows');
    rows.push(...result.data);
    if (result.data.length < pageSize) return { data: rows, error: null };
  }
}
